import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';

export default class MarkdownField extends Component {
  validate = (value) => {
    const { field, isConstructorForm } = this.props;
    const { required } = field;
    let error;
    if (!isConstructorForm && required && !value) {
      error = 'This field is required';
    }
    return error;
  };

  render() {
    const { field } = this.props;
    return (
      <>
        <Field
          type="markdown"
          as="textarea"
          name={field.fieldName}
          className="form-control form-control-sm"
          validate={this.validate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          height="100px"
          width="200px"
          rows={1}
          title={field.fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}
